<template>
<div class="container-fluid pt-3" >
    <b-row>
      <!-- input col -->
      <b-col sm="8"> 
        <!-- image & info -->
        <b-row>  
          <!-- image -->
          <b-col sm="2" >
              <b-img :src="paymentInfo.image+'?'+Date()" height="140" width="120" />
          </b-col>
          <!-- hlID, name, paid, no -->
          <b-col>
            <b-row>
              <!-- H.L.ID -->
              <b-col sm="6" class="">
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text >
                      <strong v-if="english">Pilgrim.ID</strong>
                      <strong v-else>হজ্জযাত্রী আইডিঃ</strong>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input id="hlID" type="text"
                  :disabled="paymentInfo.status" 
                  v-model="paymentInfo.hlID"  
                  ></b-form-input>
                </b-input-group> 
              </b-col>
              <!-- prilgrim's Name -->
              <b-col sm="10" class=" pt-2 pr-0" >
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text >
                      <strong v-if="english">Pilgrim's Name</strong>
                      <strong v-else>১।হজ্জযাত্রীর নাম</strong>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input id="name" type="text" readonly
                    v-model="paymentInfo.name"
                    ></b-form-input>
                </b-input-group> 
              </b-col>
              <!--installment paid -->
              <b-col sm="5" class=" pt-3" >
                <b-input-group >
                  <b-input-group-prepend>
                    <b-input-group-text >
                      <strong v-if="english">Number Of Payments</strong>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input id="bdt" type="text" readonly
                  v-model="paymentInfo.numberOfPayments"
                  ></b-form-input>
                </b-input-group> 
              </b-col>
              <!--amount paid -->
              <b-col sm="7" class="pl-0 pt-3" >
                <b-input-group >
                  <b-input-group-prepend>
                    <b-input-group-text >
                      <strong v-if="english">Amount paid</strong>
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input id="bdt" type="text" readonly
                  v-model="amountPaid"
                  ></b-form-input>
                </b-input-group> 
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- info form -->
        <b-form @submit='onProcess' @reset="onReset">
          <!-- new payment -->
          <b-row class="pt-3">
            <!-- purpose -->
            <b-col sm="6">
              <b-input-group >
                <b-input-group-prepend>
                  <b-input-group-text >
                    <strong v-if="english">Payment type</strong>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-select id="purpose" :options="paymentPurpose"
                v-model="newPayment.purpose"
                type="text"
                />
              </b-input-group> 
            </b-col>
            <!-- payment no -->
            <b-col sm="4" v-if="newPayment.purpose">
              <b-input-group >
                <b-input-group-prepend>
                  <b-input-group-text >
                    <strong v-if="english">Payment No#</strong>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input id="number"
                v-model="newPayment.paymentNo"
                readonly
                type="text"
                />
              </b-input-group> 
            </b-col>
            <!-- amount -->
            <b-col sm="6" class="pt-2" v-if="newPayment.purpose">
              <b-input-group >
                <b-input-group-prepend>
                  <b-input-group-text >
                    <strong v-if="english">Amount</strong>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input id="amount"
                v-model="newAmount"
                :state="Boolean(newPayment.amount)"
                type="text"
                :formatter="formatToBDT"
                lazy-formatter
                required
                />
              </b-input-group> 
            </b-col>
          </b-row>
          <!-- form buttons -->
          <b-row class="form-group pt-5" >
            <b-col cols="4" align-h="around" v-if="newPayment.amount">
              <b-button type="submit"
              variant="info" v-b-tooltip.hover
              title="Process and go to money receipt"
              >Process installment No# {{newPayment.paymentNo}}</b-button>
            </b-col>
            <b-col cols="4" align-h="around" >
              <b-button type="reset" variant='warning' >Reset</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-col>

      <!-- payment history table -->
      <b-col sm="4" class="pl-0 pr-0">
        <b-row>
        <b-table 
        style="max-height: 570px; display:block; overflow-y: auto; overflow-x: auto;"
        hover outlined small show-empty
        class="mb-0 table-outline"
        head-variant="dark"
        responsive="sm"
        :items="invoiceHistory"
        :fields="invoiceHistoryFields"
        >
        <div slot="date" slot-scope="item">
          <div>
            <h5>
            <strong> {{ item.item.date }} </strong>
            </h5>
          </div>
        </div>
        <div slot="purpose" slot-scope="item">
          <h5>
            <b-badge style="width: 9rem;" v-bind:class="{ 
              'text-wrap badge-info': (item.item.onAccountOf).search('Hajj') > -1,
              'text-wrap badge-success': (item.item.onAccountOf).search('Omrah') > -1,
              'text-wrap badge-light': (item.item.onAccountOf).search('Pre-registation') > -1,
              'text-wrap badge-dark': (item.item.onAccountOf).search('Other') > -1
            }">
            {{item.item.onAccountOf}}
            </b-badge>
          </h5>
          <!-- <div>
            {{item.value}}
          </div> -->
        </div>
        <div slot="amount"  slot-scope="item">
          <div>
            <h5>
            <strong> {{ formatToBDT(item.item.amount) }} </strong>
            </h5>
          </div>
        </div>
        </b-table>
        </b-row>
        <!-- <b-row class="pt-2" align-h="end">
          <b-col cols="4" class="pr-0">
            <h5><strong>Total Received:</strong></h5>
          </b-col>
          <b-col cols="6">
            <h5><strong>{{ this.formatToBDT(paymentInfo.amountPaid) }}</strong></h5>
          </b-col>
        </b-row> -->
      </b-col>
    </b-row>
	</div>
</template>

<script>
import axios from 'axios'
import VueNotifications from 'vue-notifications'

export default {
  name: 'installment',
  props: [
    'fromRow'
  ],
	computed: {
    amountPaid:{
      get(){
        return this.formatToBDT(this.paymentInfo.amountPaid);
      }
    },
    newAmount:{
      get(){

      },
      set(val){
        this.newPayment.amount = this.toNumber(val);
      }
    }
  },
  created(){
    if(typeof this.$route.params.pilgrim == 'object'){
      this.pilgrim = this.$route.params.pilgrim;
      this.paymentInfo.name = this.$route.params.pilgrim.name;
      this.paymentInfo.image = this.$route.params.pilgrim.image;
      this.paymentInfo.hlID = this.$route.params.pilgrim.HLID;
      this.paymentInfo.addr = this.$route.params.pilgrim.presentAddr;
      this.paymentInfo.numberOfPayments = this.$route.params.pilgrim.payment.count;
      this.paymentInfo.amountPaid = this.$route.params.pilgrim.payment.paid;
      this.getInvoiceHistory(this.paymentInfo.hlID);
    }
  },
  updated(){
    this.newPayment.paymentNo= this.paymentInfo.numberOfPayments +1;
    this.newPayment.hlID = this.paymentInfo.hlID;
    this.newPayment.name = this.paymentInfo.name;
    this.newPayment.addr =  this.paymentInfo.addr;
    
  },
	data(){
		return{
      english:true,
      paymentPurpose:[
        {text:"Select purpose", value:null},
        "Pre-registration",
        "Hajj",
        "Omrah",
        "Other"
      ],
      invoiceHistory:[],
      rawHistory:{},
      invoiceHistoryFields:[
        {date: { label: 'Date'}},
        {purpose: { label: 'Purpose', sortable:true}},
        {amount: { label: 'Amount'}}
      ],
      pilgrim:{},
      paymentInfo:{
        hlID:"",
        name:"",
        image:"",
        numberOfPayments:0,
        amountPaid:0,
        addr:""
      },
      newPayment:{
        hlID:"",
        name:"",
        purpose:null,
        amount:0,
        paymentNo:0,
        addr:""
      }
		}
	},
	methods:{
    getInvoiceHistory(HLID_){
      // axios.get(`http://192.168.100.107:8080/pilgrimDB/invoiceHistory.php`,{
      axios.get( `pilgrimDB/invoiceHistory.php`,{
      params:{ HLID: HLID_ }, withCredentials: true
      })
      .then(response => {
        this.invoiceHistory=[];
        this.rawHistory = response.data;
        response.data.forEach( (elm, it, arr) => {
          this.invoiceHistory.push( JSON.parse(elm['invoice']));
          // console.log(this.invoiceHistory);
        })
      })
      .catch(error => {
        if(!error.response){
          this.showErrorMsg({title:"Network Error!!"})
        }
        else{
          this.showErrorMsg({title:error.response})
        }
        console.log(error);
      });
    },
    toNumber(val){
      return parseFloat((val.toString().replace(/[A-Z]|[a-z]|,/g ,'')));
    },
    formatToBDT(val){
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'BDT' }).format(this.toNumber(val));
    },
    onProcess(evt){
      evt.preventDefault();
      // alert(JSON.stringify(this.paymentInfo, null, 1));
      this.$router.push({
        name:'Invoice', 
        params:{
          pay:{ 
            who: this.pilgrim, 
            invoice: this.newPayment 
          }
        } 
      });
    },
    onReset(evt){
      evt.preventDefault();
      this.newPayment.purpose=null,
      this.newPayment.purposeamount=0
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      message: '',
      position: "topRight",
      timeout: 5000
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: '',
      message: '',
      position: "topRight",
      timeout: 5000

    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: '',
      message: '',
      position: "topRight",
      timeout: 10000

    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      message: '',
      position: "topRight",
      timeout: 10000
    }
  }
}
</script>

<style>
#hlID,#name,#package,#bdt,#installmentNO, #purpose, 
#number, #amount
  {
    color:black !important;
    font-size: 15px !important;
  }
</style>


    